function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

(function (i, s) {
  (typeof exports === "undefined" ? "undefined" : _typeof(exports)) == "object" && typeof module != "undefined" ? s(exports, require("react")) : typeof define == "function" && define.amd ? define(["exports", "react"], s) : (i = typeof globalThis != "undefined" ? globalThis : i || self, s(i["@mantine/hooks"] = {}, i.React));
})(this, function (i, s) {
  "use strict";

  function L() {
    return "mantine-".concat(Math.random().toString(36).substr(2, 9));
  }

  function q(e) {
    return typeof e != "string" ? "" : e.charAt(0).toUpperCase() + e.slice(1);
  }

  function H(e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ["mousedown", "touchstart"];
    var n = s.useRef();
    return s.useEffect(function () {
      var o = function o(r) {
        n.current && !n.current.contains(r.target) && e();
      };

      return t.forEach(function (r) {
        return document.addEventListener(r, o);
      }), function () {
        t.forEach(function (r) {
          return document.removeEventListener(r, o);
        });
      };
    }, [n, e]), n;
  }

  function Q() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$timeout = _ref.timeout,
        e = _ref$timeout === void 0 ? 2e3 : _ref$timeout;

    var _s$useState = s.useState(null),
        _s$useState2 = _slicedToArray(_s$useState, 2),
        t = _s$useState2[0],
        n = _s$useState2[1],
        _s$useState3 = s.useState(!1),
        _s$useState4 = _slicedToArray(_s$useState3, 2),
        o = _s$useState4[0],
        r = _s$useState4[1],
        _s$useState5 = s.useState(null),
        _s$useState6 = _slicedToArray(_s$useState5, 2),
        u = _s$useState6[0],
        d = _s$useState6[1],
        f = function f(v) {
      clearTimeout(u), d(setTimeout(function () {
        return r(!1);
      }, e)), r(v);
    };

    return {
      copy: function copy(v) {
        "clipboard" in navigator ? navigator.clipboard.writeText(v).then(function () {
          return f(!0);
        }).catch(function (a) {
          return n(a);
        }) : n(new Error("useClipboard: navigator.clipboard is not supported"));
      },
      reset: function reset() {
        r(!1), n(null), clearTimeout(u);
      },
      error: t,
      copied: o
    };
  }

  function B(e, t) {
    try {
      return e.addEventListener("change", t), function () {
        return e.removeEventListener("change", t);
      };
    } catch (n) {
      return e.addListener(t), function () {
        return e.removeListener(t);
      };
    }
  }

  function K(e) {
    return typeof window != "undefined" && "matchMedia" in window ? window.matchMedia(e).matches : !1;
  }

  function g(e) {
    var _s$useState7 = s.useState(K(e)),
        _s$useState8 = _slicedToArray(_s$useState7, 2),
        t = _s$useState8[0],
        n = _s$useState8[1],
        o = s.useRef();

    return s.useEffect(function () {
      if ("matchMedia" in window) return o.current = window.matchMedia(e), n(o.current.matches), B(o.current, function (r) {
        return n(r.matches);
      });
    }, [e]), t;
  }

  function W() {
    return g("(prefers-color-scheme: dark)") ? "dark" : "light";
  }

  function U(e, t) {
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
      leading: !1
    };

    var _s$useState9 = s.useState(e),
        _s$useState10 = _slicedToArray(_s$useState9, 2),
        o = _s$useState10[0],
        r = _s$useState10[1],
        u = s.useRef(!1),
        d = s.useRef(null),
        f = s.useRef(!1),
        p = function p() {
      return window.clearTimeout(d.current);
    };

    return s.useEffect(function () {
      u.current && (!f.current && n.leading ? (f.current = !0, r(e)) : (p(), d.current = window.setTimeout(function () {
        f.current = !1, r(e);
      }, t)));
    }, [e, n.leading]), s.useEffect(function () {
      return u.current = !0, p;
    }, []), [o, p];
  }

  function z(e) {
    s.useLayoutEffect(function () {
      typeof e == "string" && e.trim().length > 0 && (document.title = e.trim());
    }, [e]);
  }

  var G = /input|select|textarea|button|object/,
      I = "a, input, select, textarea, button, object, [tabindex]";

  function J(e) {
    return process.env.NODE_ENV === "test" ? !1 : e.offsetWidth <= 0 && e.offsetHeight <= 0 || e.style.display === "none";
  }

  function X(e) {
    var t = e;

    for (; t && t !== document.body;) {
      if (J(t)) return !1;
      t = t.parentNode;
    }

    return !0;
  }

  function N(e) {
    var t = e.getAttribute("tabindex");
    return t === null && (t = void 0), parseInt(t, 10);
  }

  function S(e) {
    var t = e.nodeName.toLowerCase(),
        n = !Number.isNaN(N(e));
    return (G.test(t) && !e.disabled || e instanceof HTMLAnchorElement && e.href || n) && X(e);
  }

  function P(e) {
    var t = N(e);
    return (Number.isNaN(t) || t >= 0) && S(e);
  }

  function F(e) {
    return Array.from(e.querySelectorAll(I)).filter(P);
  }

  var R = [];

  var h = null,
      _ = !1;

  function D() {
    _ = !0;
  }

  function A() {
    if (_) {
      if (_ = !1, !h || !h || h.contains(document.activeElement)) return;
      (F(h)[0] || h).focus();
    }
  }

  function Y() {
    R.push(document.activeElement);
  }

  function Z() {
    var e = null;

    try {
      e = R.pop(), e && e.focus();
    } catch (t) {
      console.warn(["[@mantine/hooks/use-focus-trap] Focus was returned to", e, "but dom node does not exist"].join(" "));
    }
  }

  function x(e) {
    h = e, document.addEventListener("focusout", D, !1), document.addEventListener("focusin", A, !0);
  }

  function ee() {
    h = null, document.removeEventListener("focusout", D), document.removeEventListener("focusin", A);
  }

  function te(e, t) {
    var n = F(e);

    if (!n.length) {
      t.preventDefault();
      return;
    }

    if (!(n[t.shiftKey ? 0 : n.length - 1] === document.activeElement || e === document.activeElement)) return;
    t.preventDefault();
    var u = n[t.shiftKey ? n.length - 1 : 0];
    u && u.focus();
  }

  function ne(e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "body > :not(script)";
    var n = Array.from(document.querySelectorAll(t)).map(function (o) {
      if (o.contains(e)) return;
      var r = o.getAttribute("aria-hidden");
      return (r === null || r === "false") && o.setAttribute("aria-hidden", "true"), {
        node: o,
        ariaHidden: r
      };
    });
    return function () {
      n.forEach(function (o) {
        !o || (o.ariaHidden === null ? o.node.removeAttribute("aria-hidden") : o.node.setAttribute("aria-hidden", o.ariaHidden));
      });
    };
  }

  function re() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
    var t = s.useRef(),
        n = s.useRef(null),
        o = s.useCallback(function (r) {
      if (n.current && n.current(), t.current && (Z(), ee()), e && r) {
        x(r), Y();

        var u = function u(d) {
          n.current = ne(d);
          var f = r.querySelector("[data-autofocus]");

          if (!f) {
            var p = Array.from(r.querySelectorAll(I));
            f = p.find(P) || p.find(S) || null, !f && S(r) && (f = r);
          }

          f ? f.focus() : process.env.NODE_ENV === "development" && console.warn("[@mantine/hooks/use-focus-trap] Failed to find focusable element within provided node", r);
        };

        setTimeout(function () {
          r.ownerDocument ? u(r) : process.env.NODE_ENV === "development" && console.warn("[@mantine/hooks/use-focus-trap] Ref node is not part of the dom", r);
        }), t.current = r;
      } else t.current = null;
    }, [e]);
    return s.useEffect(function () {
      if (!e) return;

      var r = function r(u) {
        u.key === "Tab" && t.current && te(t.current, u);
      };

      return document.addEventListener("keydown", r), function () {
        document.removeEventListener("keydown", r);
      };
    }, [e]), o;
  }

  var oe = Object.defineProperty,
      se = Object.defineProperties,
      ue = Object.getOwnPropertyDescriptors,
      C = Object.getOwnPropertySymbols,
      ce = Object.prototype.hasOwnProperty,
      ie = Object.prototype.propertyIsEnumerable,
      j = function j(e, t, n) {
    return t in e ? oe(e, t, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: n
    }) : e[t] = n;
  },
      O = function O(e, t) {
    for (var n in t || (t = {})) {
      ce.call(t, n) && j(e, n, t[n]);
    }

    if (C) {
      var _iterator = _createForOfIteratorHelper(C(t)),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var n = _step.value;
          ie.call(t, n) && j(e, n, t[n]);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }

    return e;
  },
      T = function T(e, t) {
    return se(e, ue(t));
  };

  function ae(_ref2) {
    var e = _ref2.initialValues,
        _ref2$validationRules = _ref2.validationRules,
        t = _ref2$validationRules === void 0 ? {} : _ref2$validationRules;

    var n = Object.keys(e).reduce(function (c, l) {
      return c[l] = !1, c;
    }, {}),
        _s$useState11 = s.useState(n),
        _s$useState12 = _slicedToArray(_s$useState11, 2),
        o = _s$useState12[0],
        r = _s$useState12[1],
        _s$useState13 = s.useState(e),
        _s$useState14 = _slicedToArray(_s$useState13, 2),
        u = _s$useState14[0],
        d = _s$useState14[1],
        f = function f() {
      return r(n);
    },
        p = function p() {
      d(e), f();
    },
        w = function w() {
      var c = !0;
      var l = Object.keys(u).reduce(function (E, y) {
        return t && typeof t[y] == "function" && !t[y](u[y]) ? (E[y] = !0, c = !1) : E[y] = !1, E;
      }, {});
      return r(l), c;
    },
        v = function v(c) {
      return r(function (l) {
        return T(O({}, l), _defineProperty({}, c, typeof t[c] == "function" ? !t[c](u[c]) : !1));
      });
    },
        a = function a(c, l) {
      return r(function (E) {
        return T(O({}, E), _defineProperty({}, c, l));
      });
    };

    return {
      values: u,
      errors: o,
      validate: w,
      reset: p,
      setErrors: r,
      setValues: d,
      setFieldValue: function setFieldValue(c, l) {
        d(function (E) {
          return T(O({}, E), _defineProperty({}, c, l));
        }), a(c, !1);
      },
      setFieldError: a,
      validateField: v,
      resetErrors: f,
      onSubmit: function onSubmit(c) {
        return function (l) {
          l && l.preventDefault(), w() && c(u);
        };
      }
    };
  }

  function fe(e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : L;
    var n = s.useRef(t());
    return e || n.current;
  }

  function le(e, t) {
    var _s$useState15 = s.useState(!1),
        _s$useState16 = _slicedToArray(_s$useState15, 2),
        n = _s$useState16[0],
        o = _s$useState16[1],
        r = s.useRef(),
        u = function u() {
      o(!0), r.current = window.setInterval(e, t);
    },
        d = function d() {
      o(!1), window.clearInterval(r.current);
    };

    return {
      start: u,
      stop: d,
      toggle: function toggle() {
        n ? d() : u();
      },
      active: n
    };
  }

  var de = typeof document != "undefined" ? s.useLayoutEffect : s.useEffect;

  var pe = Object.defineProperty,
      me = Object.defineProperties,
      be = Object.getOwnPropertyDescriptors,
      M = Object.getOwnPropertySymbols,
      ve = Object.prototype.hasOwnProperty,
      we = Object.prototype.propertyIsEnumerable,
      k = function k(e, t, n) {
    return t in e ? pe(e, t, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: n
    }) : e[t] = n;
  },
      he = function he(e, t) {
    for (var n in t || (t = {})) {
      ve.call(t, n) && k(e, n, t[n]);
    }

    if (M) {
      var _iterator2 = _createForOfIteratorHelper(M(t)),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var n = _step2.value;
          we.call(t, n) && k(e, n, t[n]);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }

    return e;
  },
      Ee = function Ee(e, t) {
    return me(e, be(t));
  };

  function ye() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    var _s$useState17 = s.useState(e),
        _s$useState18 = _slicedToArray(_s$useState17, 2),
        t = _s$useState18[0],
        n = _s$useState18[1];

    return [t, {
      setState: n,
      append: function append() {
        for (var _len = arguments.length, a = new Array(_len), _key = 0; _key < _len; _key++) {
          a[_key] = arguments[_key];
        }

        return n(function (m) {
          return [].concat(_toConsumableArray(m), a);
        });
      },
      prepend: function prepend() {
        for (var _len2 = arguments.length, a = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          a[_key2] = arguments[_key2];
        }

        return n(function (m) {
          return [].concat(a, _toConsumableArray(m));
        });
      },
      insert: function insert(a) {
        for (var _len3 = arguments.length, m = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
          m[_key3 - 1] = arguments[_key3];
        }

        return n(function (b) {
          return [].concat(_toConsumableArray(b.slice(0, a)), m, _toConsumableArray(b.slice(a)));
        });
      },
      apply: function apply(a) {
        return n(function (m) {
          return m.map(function (b, c) {
            return a(b, c);
          });
        });
      },
      remove: function remove() {
        for (var _len4 = arguments.length, a = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
          a[_key4] = arguments[_key4];
        }

        return n(function (m) {
          return m.filter(function (b, c) {
            return !a.includes(c);
          });
        });
      },
      reorder: function reorder(_ref3) {
        var a = _ref3.from,
            m = _ref3.to;
        return n(function (b) {
          var c = _toConsumableArray(b),
              l = b[a];

          return c.splice(a, 1), c.splice(m, 0, l), c;
        });
      },
      setItem: function setItem(a, m) {
        return n(function (b) {
          var c = _toConsumableArray(b);

          return c[a] = m, c;
        });
      },
      setItemProp: function setItemProp(a, m, b) {
        return n(function (c) {
          var l = _toConsumableArray(c);

          return l[a] = Ee(he({}, l[a]), _defineProperty({}, m, b)), l;
        });
      }
    }];
  }

  function V(e, t, n) {
    s.useEffect(function () {
      return window.addEventListener(e, t, n), function () {
        return window.removeEventListener(e, t, n);
      };
    }, []);
  }

  function ge(_ref4) {
    var e = _ref4.key,
        _ref4$defaultValue = _ref4.defaultValue,
        t = _ref4$defaultValue === void 0 ? void 0 : _ref4$defaultValue;

    var _s$useState19 = s.useState(typeof window != "undefined" && "localStorage" in window ? window.localStorage.getItem(e) : t != null ? t : ""),
        _s$useState20 = _slicedToArray(_s$useState19, 2),
        n = _s$useState20[0],
        o = _s$useState20[1],
        r = s.useCallback(function (u) {
      typeof u == "function" ? o(function (d) {
        var f = u(d);
        return window.localStorage.setItem(e, f), f;
      }) : (window.localStorage.setItem(e, u), o(u));
    }, [e]);

    return V("storage", function (u) {
      u.storageArea === window.localStorage && u.key === e && o(u.newValue);
    }), s.useEffect(function () {
      t && !n && r(t);
    }, [t, n, r]), [n, r];
  }

  function Se() {
    for (var _len5 = arguments.length, e = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      e[_key5] = arguments[_key5];
    }

    return function (t) {
      e.forEach(function (n) {
        typeof n == "function" ? n(t) : n != null && (n.current = t);
      });
    };
  }

  function _e(_ref5) {
    var _ref5$initialValues = _ref5.initialValues,
        e = _ref5$initialValues === void 0 ? [] : _ref5$initialValues,
        t = _ref5.limit;

    var _s$useState21 = s.useState({
      state: e.slice(0, t),
      queue: e.slice(t)
    }),
        _s$useState22 = _slicedToArray(_s$useState21, 2),
        _s$useState22$ = _s$useState22[0],
        n = _s$useState22$.state,
        o = _s$useState22$.queue,
        r = _s$useState22[1];

    return {
      state: n,
      queue: o,
      add: function add() {
        for (var _len6 = arguments.length, p = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
          p[_key6] = arguments[_key6];
        }

        return r(function (w) {
          var v = [].concat(_toConsumableArray(w.state), _toConsumableArray(w.queue), p);
          return {
            state: v.slice(0, t),
            queue: v.slice(t)
          };
        });
      },
      update: function update(p) {
        return r(function (w) {
          var v = p([].concat(_toConsumableArray(w.state), _toConsumableArray(w.queue)));
          return {
            state: v.slice(0, t),
            queue: v.slice(t)
          };
        });
      },
      cleanQueue: function cleanQueue() {
        return r(function (p) {
          return {
            state: p.state,
            queue: []
          };
        });
      }
    };
  }

  function Oe() {
    return g("(prefers-reduced-motion: reduce)");
  }

  var $ = function $(e) {
    e.preventDefault();
  };

  function Te(e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      disableTouchEvents: !1
    };

    var n = s.useRef(!1),
        o = s.useRef(null),
        r = function r() {
      n.current && (n.current = !1, document.body.style.overflow = o.current || "", t.disableTouchEvents && document.body.removeEventListener("touchmove", $));
    },
        u = function u() {
      n.current = !0, o.current = document.body.style.overflow, document.body.style.overflow = "hidden", t.disableTouchEvents && document.body.addEventListener("touchmove", $, {
        passive: !1
      });
    };

    s.useEffect(function () {
      return e ? u() : r(), r;
    }, [e]);
  }

  i.randomId = L, i.upperFirst = q, i.useClickOutside = H, i.useClipboard = Q, i.useColorScheme = W, i.useDebouncedValue = U, i.useDocumentTitle = z, i.useFocusTrap = re, i.useForm = ae, i.useId = fe, i.useInterval = le, i.useIsomorphicEffect = de, i.useListState = ye, i.useLocalStorageValue = ge, i.useMediaQuery = g, i.useMergedRef = Se, i.useQueue = _e, i.useReducedMotion = Oe, i.useScrollLock = Te, i.useWindowEvent = V, Object.defineProperty(i, "__esModule", {
    value: !0
  });
});